import * as toastr from 'toastr';
import { call, put, takeEvery} from 'redux-saga/effects'
import {ACTION_TYPES, createAction} from "../actions";
import {updateEntityByFullUid} from "../../http/updateEntityByFullUid";
import {Geometry} from "geojson";

export function* updateEntitySaga () {
    yield takeEvery(ACTION_TYPES.UPDATE_ENTITY, updateEntity);
}

export function* updateEntity (action: any) {
    const payload: {fullUid: string, type: string, oldType: string, patch: {[key: string]: string}, geometry: Geometry} = action.payload;
    try {
        const {fullUid, type, patch, geometry, oldType} = payload;
        const entity = yield call(updateEntityByFullUid, fullUid, patch);
        if (entity) toastr.success(`Updated entity ${entity.name}`);
        yield put(createAction(ACTION_TYPES.UPDATE_ENTITY_SUCCESS, {
            fullUid, type, patch: entity, geometry, oldType,
        }));
    } catch (error) {
        toastr.error(`Failed to update entity`);
        yield put(createAction(ACTION_TYPES.UPDATE_ENTITY_ERROR, {error}));
    }
}
